/**
 * DrawerLoadingFallback — fallback dùng chung cho MỌI popup/drawer lazy.
 *
 * Vì sao phải có (sếp Phú 25.08.2026 "bấm card bị giật, trắng rồi mới lên popup"):
 * các DrawerProvider trước đây để `<Suspense fallback={null}>`. Chunk drawer chưa nằm trong
 * sổ prefetch ⇒ bấm card xong màn hình KHÔNG phản hồi gì trong vài trăm ms, rồi popup bật ra
 * đột ngột — mắt đọc đúng thành "đơ rồi nháy".
 *
 * Vẽ overlay mờ + spinner giữa màn (KHÔNG vẽ panel trắng theo bề ngang drawer thật): mỗi drawer
 * một bề rộng khác nhau, vẽ sai một cái là panel giả nhảy sang panel thật ngay trước mắt.
 * Overlay thì trùng khít với mọi drawer.
 *
 * Fade-in 90ms: chunk đã prefetch thường về trong ~10ms, chớp một cái còn khó chịu hơn.
 */

import ReactDOM from 'react-dom';
import { Loader2 } from 'lucide-react';

export default function DrawerLoadingFallback({ onClose, width }) {
  if (typeof document === 'undefined') return null;
  const widthCss = typeof width === 'number' ? `${width}px` : width;
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999]" style={{ animation: 'cnvDrawerVeil .12s ease .09s both' }}>
      <style>{'@keyframes cnvDrawerVeil{from{opacity:0}to{opacity:1}}'}</style>
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      {width ? (
        // Nơi gọi BIẾT bề rộng drawer thật (vd ticket 1500px) → dựng luôn panel cho khớp,
        // drawer thật vào thế chỗ mà không nhảy.
        <div
          className="absolute top-0 right-0 h-full bg-white shadow-2xl md:border-l md:border-gray-200 flex items-center justify-center max-md:!w-full"
          style={{ width: widthCss, maxWidth: '95vw' }}
        >
          <Loader2 size={28} className="animate-spin text-blue-500" />
        </div>
      ) : (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <Loader2 size={28} className="animate-spin text-white/90" />
        </div>
      )}
    </div>,
    document.body,
  );
}
